import React from 'react';
import { Text } from '@ayble-health/dashboard-components';
import type { EliminationBlockData } from '../../../models/eliminationBlockData';
import type { FoodChallengeBlockData } from '../../../models/foodChallengeBlockData';
import type { AnyNutritionBlockData } from '../../../models/nutritionBlockData';
import type { SuspectIdentificationBlockData } from '../../../models/suspectIdentificationBlockData';
import { EliminationDetailsContent } from './EliminationDetailsContent';
import { FoodChallengeDetailsContent } from './FoodChallengeDetailsContent';
import { SuspectIdentificationDetailsContent } from './SuspectIdentificationDetailsContent';
import {
  BLOCK_STABLE_STRINGS,
  BlockStableStrings,
} from '../../../models/block';

type Props = {
  nutritionBlockData: AnyNutritionBlockData | null;
  nutritionBlockType: BlockStableStrings | null;
};

export const NutritionBlockDetailsContent = ({
  nutritionBlockData,
  nutritionBlockType,
}: Props) => {
  if (!nutritionBlockData || !nutritionBlockType) {
    return (
      <Text color={'blueGray.600'} fontSize={'sm'}>
        No app data available for this block.
      </Text>
    );
  }

  if (nutritionBlockType === BLOCK_STABLE_STRINGS.identifySuspects) {
    return (
      <SuspectIdentificationDetailsContent
        nutritionBlockData={
          nutritionBlockData as SuspectIdentificationBlockData
        }
      />
    );
  }

  if (nutritionBlockType === BLOCK_STABLE_STRINGS.eliminationChallenge) {
    return (
      <EliminationDetailsContent
        nutritionBlockData={nutritionBlockData as EliminationBlockData}
      />
    );
  }

  if (nutritionBlockType === BLOCK_STABLE_STRINGS.foodChallenge) {
    return (
      <FoodChallengeDetailsContent
        nutritionBlockData={nutritionBlockData as FoodChallengeBlockData[]}
      />
    );
  }

  // Never happens actually
  return null;
};
